export default __webpack_public_path__ + "static/media/pic58.f060730c.jpg";